import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" id=\"close--sprite\">\n<path d=\"M5.585 0.14H4.255L0.360001 4.035V5.365L16.7 21.705L0.360001 38.045V39.375L4.255 43.27H5.585L21.925 26.93L38.265 43.27H39.595L43.49 39.375V38.045L27.15 21.705L43.49 5.365V4.035L39.595 0.14H38.265L21.925 16.48L5.585 0.14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol